import {createGlobalStyle} from 'styled-components';

import {scrollBar} from '../../../shared-components/mixin/scroll/scrollBar';
import {colorTheme} from '../../mixin/colorTheme';

export const FormCalendarMenuList = createGlobalStyle`
    :root {
        ${colorTheme({
            '--datepicker-container-shadow': {
                dark: '0 0 19px -8px var(--black-02)',
                light: '-2px -2px 1px 0px #28368205,  1px 1px 8px 0 #2836821f',
            },
            '--datepicker-container-body-backgroud-color-01': {dark: '#35393D', light: '#FFFFFF'},
            '--datepicker-container-body-backgroud-color-02': {dark: '#3E4046', light: '#FAFAFE'},

            '--datepicker-container-header-backgroud-color': {dark: '#1B1F22', light: '#273049'},
            '--datepicker-container-selected-backgroud-color': {dark: '#f7c879', light: '#273049'},
            '--datepicker-container-selected-hover-backgroud-color': {dark: '#c4913c', light: '#414f74'},

            '--datepicker-text-label-color': {dark: '#FFFFFF', light: '#b4c2e5'},
            '--datepicker-text-day-current-color': {dark: '#FFFFFF', light: '#232323'},
            '--datepicker-text-day-selected-color': {dark: '#FFFFFF', light: '#cbd8ff'},
            '--datepicker-text-day-out-month-color': {dark: '#62646B', light: '#D6D8E6'},
        })};
    }
    
   

    // --------------------------------- //
    // === Date picker group styling === //
    // --------------------------------- //
    .form-datepicker-container.react-datepicker ,
    .form-datepicker-container .react-datepicker__month-container {
        background: var(--datepicker-container-body-backgroud-color-01);
    }
    .form-datepicker-container .react-datepicker__current-month,
    .form-datepicker-container .react-datepicker__day-names,
    .form-datepicker-container .react-datepicker__day-name,
    .form-datepicker-container .react-datepicker-time__header {
        color: var(--datepicker-text-label-color);
    }
    .form-datepicker-container .react-datepicker__day-name, 
    .form-datepicker-container .react-datepicker__day, 
    .form-datepicker-container .react-datepicker__time-name {
        margin: 4px;
    }

    // ------------------------------------- //
    // === Date picker container styling === //
    // ------------------------------------- //
    .form-datepicker-container.react-datepicker {
        pointer-events: visible;
        cursor: default;
        border: none;
        box-shadow: var(--datepicker-container-shadow);
        overflow: hidden;
    }
    #datepicker-portal .react-datepicker-popper {
        z-index: 9999!important;
    }
    .form-datepicker-container.react-datepicker::before,
    .form-datepicker-container .react-datepicker__time-container::before {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 4px;
        background-image: linear-gradient(to right, #44a39f, #eb9664);
        width: 100%;
        z-index: 1;
    }
    &.form-datepicker--day-time-picker {
        display: flex;
        .react-datepicker__time-container {
            border-left: none;
        }
    }
    &.form-datepicker--period-picker {
        display: flex;
    }

    // ---------------------------------- //
    // === Date picker header styling === //
    // ---------------------------------- //
    .form-datepicker-container .react-datepicker__navigation {
        width: 22px;
        top: 2px;
        &--next,
        &--previous {
            .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next::before,
            .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous::before {
                border-color: var(--datepicker-text-label-color);
                border-width: 1.5px 1.5px 0 0;
            }
            top: 10px;
        }
        &--next {
            right: unset;
            left: 40px;
        }
        &--previous {
            left: 15px;
        }
    }

    .form-datepicker-container .react-datepicker__header {
        background: var(--datepicker-container-header-backgroud-color);
        padding: 34px 16px 64px;
        height: 77px;
        border: none;
        .react-datepicker__current-month {
            font-size: 25px;
            text-align: left;
            padding: 0px 0 2px 6px;
        }
        &.react-datepicker__header--time.react-datepicker__header--time--only {
            padding: 10px 16px;
            height: unset;
        }
    }
    
    .form-datepicker-container .react-datepicker__day-name{
        font-weight: 300;
        font-size: 12px;
    }


    // -------------------------------- //
    // === Date picker body styling === //
    // -------------------------------- //
    .form-datepicker-container {
        .react-datepicker__month { 
            margin: 16px;
        }

        .react-datepicker__day {
            color: var(--datepicker-text-day-current-color);
        }
        .react-datepicker__day--weekend {
            color: var(--slate-06);
        } 
        .react-datepicker__day--outside-month,
        .react-datepicker__day--outside-month.react-datepicker__day--weekend {
            color: var(--datepicker-text-day-out-month-color);
        }
        .react-datepicker__day,
        .react-datepicker__day--weekend,
        .react-datepicker__day--outside-month,
        .react-datepicker__day--outside-month.react-datepicker__day--weekend{
            &:hover {
                transition: 0.3s;
                color: #ECF8FF;
                background: #2087BD;
            }
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected, 

        .react-datepicker__week .react-datepicker__day.react-datepicker__day--selected,
        .react-datepicker__time-list-item.react-datepicker__time-list-item--selected,
        &.form-datepicker--Week-picker .react-datepicker__day.react-datepicker__day--selected.react-datepicker__day--in-range {
            color: var(--datepicker-text-day-selected-color) !important;
            background: var(--datepicker-container-selected-backgroud-color) !important;
        }
        &.form-datepicker--Week-picker .react-datepicker__week:hover {
            .react-datepicker__day {
                color: #ECF8FF;
                background: #2087BD;
                border-radius: 4px;
            }
            .react-datepicker__day.react-datepicker__day--selected.react-datepicker__day--in-range {
                color: #ECF8FF;
                background: var(--datepicker-container-selected-hover-backgroud-color)!important;
                border-radius: 4px;
            }
        } 
        .react-datepicker__week-number{
            color: var(--slate-06);
            font-weight: 400;
            font-size: 10px;
        }

        .react-datepicker__day.react-datepicker__day--today{
            font-weight: 900;
        }

    }
    // -------------------------------- //
    // === TIME picker body styling === //
    // -------------------------------- //
    .form-datepicker-container{
        .react-datepicker__time-list {
            background:var(--datepicker-container-body-backgroud-color-02);
            ${scrollBar};
            padding: 10px 0!important;
            color: var(--datepicker-text-day-current-color)!important;
            max-height: 170px;
        }
        .react-datepicker__time-list-item{
            padding: 4px 10px!important;
            &:hover {
                color: #ECF8FF !important;
                background: #2087BD !important;
            }
            &.react-datepicker__time-list-item--selected:hover {
                color: #ECF8FF!important;
                background: var(--datepicker-container-selected-hover-backgroud-color)!important;
            }
        }
    }
    .form-datepicker-container .react-datepicker__day--in-range,
    .react-datepicker__day--keyboard-selected.react-datepicker__day--range-start.react-datepicker__day--in-range {
        color: #ECF8FF !important;
        background: #2087BD!important;
    }

    // -------------------------------- //
    // === Disabled feature styling === //
    // -------------------------------- //
    .react-datepicker__day.react-datepicker__day--disabled,
    .react-zdatepicker__day.react-datepicker__day--disabled.react-datepicker__day--outside-month,
    .react-datepicker__day.react-datepicker__day--disabled.react-datepicker__day--weekend {
        background: none!important;
        border-radius: 4px;
        opacity: 0.4;
        cursor: not-allowed;
        color: var(--label-text-color)!important;
        &:hover {
            color: var(--label-text-color)!important;
            background: none!important;
        }
    }

`;
